import React from "react";
import { Maybe } from "true-myth";

import ScheduleWeekView from "components/schedule/week_view";
import ScheduleDayView from "containers/schedule/day_view_container";
import TimeBlockContainer from "containers/schedule/time_block_modal_container";

import { ISchedule } from "types/schedules";

interface IScheduleTable {
  dayView: Maybe<Date>;
  schedule: ISchedule;
  startDate: Date;
  endDate: Date;
  interactiveView: boolean;
  tableRef?: React.MutableRefObject<HTMLTableElement | null>;
  clearFilters?: () => void;
}

function ScheduleTable({
  dayView,
  endDate,
  interactiveView,
  schedule,
  startDate,
  tableRef,
  clearFilters,
}: IScheduleTable) {
  const timeBlockModal = interactiveView && (
    <TimeBlockContainer interactiveView={interactiveView} />
  );

  let view;
  if (dayView.isJust() && interactiveView) {
    view = (
      <ScheduleDayView
        key="day_view"
        day={dayView.unsafelyUnwrap()}
        schedule={schedule}
      />
    );
  } else {
    view = (
      <ScheduleWeekView
        key="week_view"
        schedule={schedule}
        startDate={startDate}
        endDate={endDate}
        interactiveView={interactiveView}
        tableRef={tableRef}
        clearFilters={clearFilters}
      />
    );
  }
  return (
    <>
      {timeBlockModal}
      {view}
    </>
  );
}

export default React.memo(ScheduleTable);
